import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
	Icon,
	Button,
	Checkbox,
	Intent,
	Alert,
} from '@blueprintjs/core';

import AddEditWarehouse from './AddEditWarehouse';
import { addWarehouse, deleteWarehouse } from '../../slices/CodeTablesSlice';

import { ResultHeader, ResultHeaderWithSort, Result, TextFilter } from './ResultComponents';

function Results(props) {
	const {
		table_items,
		table_items_sort_ids,
		table_items_sort_field,
		table_items_sort_direction,
		setTableItemsSort,
		openAddEditItemDialog,
		tableItemsFilters,
		handleFilterChange,
		deleteItem,
	} = props;
	
	const sort_props = {
		setTableItemsSort:       setTableItemsSort,
		tableItemsSortField:     table_items_sort_field,
		tableItemsSortDirection: table_items_sort_direction,
	};
	
	return <div className='results mt-4 mb-4'>
		<div className='results-table'>
			<ResultHeader columnIdx={1} title='' />
			<ResultHeader columnIdx={2} title='Urejanje' />
			<ResultHeaderWithSort
				columnIdx={3} {...sort_props} title='Naziv' fieldName='title' />
			<ResultHeader columnIdx={4} title='Privzeto skladišče' />
		</div>
		
		<div className='results-table filters-row'>
			<Result columnIdx={1} />
			<Result columnIdx={2} />
			<Result columnIdx={3} child={
				<TextFilter
					value={tableItemsFilters.title}
					onChange={ event => handleFilterChange('title', event) } />
			} />
			<Result columnIdx={4} child={
				<Checkbox
					checked={tableItemsFilters.default_warehouse === 1}
					indeterminate={tableItemsFilters.default_warehouse === 0}
					onChange={event => {
						let checked = 0;
						if (tableItemsFilters.default_warehouse === 1) {
							checked = -1;
						}
						else if (tableItemsFilters.default_warehouse === 0) {
							checked = 1;
						}
						
						handleFilterChange('default_warehouse', checked);
					}} />
			} />
		</div>
		
		{table_items_sort_ids.map((id, idx) => {
			const item = table_items[id];
			
			return <div className='results-table' key={'countries-result--result-' + id}>
				<div className='results-table-col col-1' style={{ gridColumn: '1' }}>
					{ item.serial_internal_code }
				</div>
				<div className='results-table-col col-2' style={{ gridColumn: '2' }}>
					<Button
						icon='edit'
						intent='primary'
						minimal={true}
						small={true}
						onClick={() => openAddEditItemDialog(item)} />
					<Button
						icon='trash'
						intent='danger'
						minimal={true}
						small={true}
							onClick={() => deleteItem(item)} />
				</div>
				<Result columnIdx={3} child={
					item.title
				} />
				<Result columnIdx={4} child={
					item.default_warehouse ?
						<Icon icon='tick' color='#394b59' />
						:
						<Icon icon='cross' color='#ff0000' />
				} />
			</div>;
		})}
	</div>;
}

class Warehouses extends Component {
	constructor(props) {
		super(props);
		
		this.updateTableItemsFromProps = this.updateTableItemsFromProps.bind(this);
		this.setTableItemsSort         = this.setTableItemsSort        .bind(this);
		this.refreshTableItemsSort     = this.refreshTableItemsSort    .bind(this);
		this.filterTableItems          = this.filterTableItems         .bind(this);
		this.handleFilterChange        = this.handleFilterChange       .bind(this);
		this.openAddEditItemDialog     = this.openAddEditItemDialog    .bind(this);
		this.closeAddEditItemDialog    = this.closeAddEditItemDialog   .bind(this);
		this.deleteItem                = this.deleteItem               .bind(this);
		
		const {
			table_items,
			table_items_sort_ids,
			table_items_filtered_ids,
		} = this.updateTableItemsFromProps(props);
		
		this.state = {
			table_items,
			table_items_sort_ids,
			table_items_filtered_ids,
			table_items_sort_field: '',
			table_items_sort_direction: 'ASC',
			table_items_filters: {
				title: '',
				default_warehouse: 0,
			},
			add_edit_item_dialog_open: false,
			add_edit_item_dialog_item: null,
			item_delete_requested: null,
		};
	}
	
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.warehouses != this.state.table_items) {
			this.setState(
				this.updateTableItemsFromProps(this.props)
			);
		}
	}
	
	updateTableItemsFromProps(props) {
		const ids = Object.keys(props.warehouses);
		
		let sort_ids = [];
		
		if (this.state !== undefined && this.state.table_items_sort_ids !== undefined) {
			for (let i=0; i<this.state.table_items_sort_ids.length; i++) {
				const id = this.state.table_items_sort_ids[i];
				if (ids.indexOf(id) != -1) {
					sort_ids.push(id);
				}
			}
		}
		
		for (let i=0; i<ids.length; i++) {
			const id = ids[i];
			if (sort_ids.indexOf(id) == -1) {
				sort_ids.push(id);
			}
		}
		
		//TODO refresh sorting
		//TODO call this.filterTableItems(new_filters);
		
		return {
			table_items: props.warehouses,
			table_items_sort_ids: sort_ids,
			table_items_filtered_ids: ids,
		};
	}
	
	setTableItemsSort(field) {
		let direction = 'ASC';
		if (this.state.table_items_sort_field == field) {
			direction = (this.state.table_items_sort_direction == 'ASC' ? 'DESC' : 'ASC');
		}
		
		this.setState({
			table_items_sort_field:     field,
			table_items_sort_direction: direction,
		});
		
		this.refreshTableItemsSort(field, direction);
	}
	
	refreshTableItemsSort(field, direction, table_items_filtered_ids) {
		table_items_filtered_ids = table_items_filtered_ids || this.state.table_items_filtered_ids;
		
		const ids = table_items_filtered_ids;
		ids.sort((a_key, b_key) => {
			const a = this.state.table_items[a_key][field];
			const b = this.state.table_items[b_key][field];
			
			if (field == 'title') {
				return a.localeCompare(b) * (direction == 'ASC' ? 1 : -1);
			}
			
			return (a < b ? -1 : a > b ? 1 : 0) * (direction == 'ASC' ? 1 : -1);
		});
		
		this.setState({
			table_items_sort_ids: ids,
		});
	}
	
	filterTableItems(filters) {
		const filters_title             = filters.title.toUpperCase();
		const filters_default_warehouse = filters.default_warehouse;
		
		const ids = Object.keys(this.state.table_items);
		const filtered_ids = ids.filter(id => {
			const item = this.state.table_items[id];
			
			if (filters_title != '' && item.title.toUpperCase().indexOf(filters_title) == -1) {
				return false;
			}
			
			if (filters_default_warehouse !== 0 &&
				(
					(item.default_warehouse === true  && filters_default_warehouse === -1) ||
					(item.default_warehouse === false && filters_default_warehouse ===  1)
				)
			) {
				return false;
			}
			
			return true;
		});
		
		this.setState({
			table_items_filtered_ids: filtered_ids,
			table_items_filters:      filters,
		});
		
		this.refreshTableItemsSort(
			this.state.table_items_sort_field,
			this.state.table_items_sort_direction,
			filtered_ids
		);
	}
	
	handleFilterChange(field_name, event) {
		const new_filters = {
			title:             this.state.table_items_filters.title,
			default_warehouse: this.state.table_items_filters.default_warehouse,
		};
		
		let val = event;
		if (val instanceof Object) {
			val = event.target.value;
		}
		new_filters[field_name] = val;
		
		this.filterTableItems(new_filters);
	}
	
	openAddEditItemDialog(item) {
		this.setState({ add_edit_item_dialog_open: true, add_edit_item_dialog_item: item });
	}
	closeAddEditItemDialog(item) {
		this.setState({ add_edit_item_dialog_open: false });
		
		if (item !== undefined) {
			if (item.default_warehouse) {
				let current_default_warehouse = null;
				for (let id_warehouse in this.props.warehouses) {
					if (id_warehouse != item.id_warehouse && this.props.warehouses[id_warehouse].default_warehouse) {
						current_default_warehouse = this.props.warehouses[id_warehouse];
						break;
					}
				}
				
				if (current_default_warehouse !== null) {
					current_default_warehouse = { ...current_default_warehouse, default_warehouse: false };
					this.props.dispatch(addWarehouse({ item: current_default_warehouse, token: this.props.token, save_to_api: true }));
				}
			}
			
			this.props.dispatch(addWarehouse({ item, token: this.props.token, save_to_api: true }));
		}
	}
	deleteItem(item) {
		this.setState({ item_delete_requested: item, token: this.props.token });
	}
	
	render() {
		if (this.props.user === null || this.props.user === undefined || (this.props.user.access_roles ?? []).indexOf('code-tables') === -1) return null;
		
		return <>
			{this.state.item_delete_requested === null ? null :
				<Alert
					cancelButtonText='Prekliči'
					confirmButtonText='Briši'
					canEscapeKeyCancel={true}
					canOutsideClickCancel={true}
					icon='trash'
					intent={Intent.DANGER}
					isOpen={true}
					onConfirm={() => {
						this.props.dispatch(deleteWarehouse(this.state.item_delete_requested.id_warehouse));
						this.setState({ item_delete_requested: null });
					}}
					onCancel={() => {
						this.setState({ item_delete_requested: null });
					}}>
					Ali res želite izbrisati ta zapis?
				</Alert>
			}
			
			{!this.state.add_edit_item_dialog_open ? null :
				<AddEditWarehouse
					closeAddEditItemDialog={this.closeAddEditItemDialog}
					item={this.state.add_edit_item_dialog_item} />
			}
			
			<div className='flex flex-col flex-grow warehouses-list'>
				<div className='pl-4 pt-4'>
					<Button intent='primary' icon='plus' onClick={() => this.openAddEditItemDialog(null)}>
						Nov vnos
					</Button>
				</div>
				
				<div className='flex-1 pl-4 pr-4'>
					<div className='flex-grow overflow-y-auto' style={{ flexBasis: '0' }}>
						<Results
							table_items={this.state.table_items}
							table_items_sort_ids={this.state.table_items_sort_ids}
							table_items_sort_field={this.state.table_items_sort_field}
							table_items_sort_direction={this.state.table_items_sort_direction}
							setTableItemsSort={this.setTableItemsSort}
							openAddEditItemDialog={this.openAddEditItemDialog}
							tableItemsFilters={this.state.table_items_filters}
							handleFilterChange={this.handleFilterChange}
							deleteItem={this.deleteItem} />
					</div>
				</div>
			</div>
		</>;
	}
}
Warehouses.propTypes = {
};

function mapStateToProps(state) {
	return {
		warehouses: state.CodeTablesSlice.warehouses,
		token:      state.UserSlice.token,
		user:       state.UserSlice.user,
	};
}

export default connect(mapStateToProps)(Warehouses);
